import kebabCase from 'lodash.kebabcase'

import { STRIP_HTML_TAGS } from '@src/Core/Constants/PageConstants'

export const getDOMIdFromString = (text: string): string =>
    kebabCase(text.replace(/^[0-9]*/g, '').replace(STRIP_HTML_TAGS, ''))
